import { Component, Input } from '@angular/core';

import { IPostFooter } from './post-footer.types';
import { NX23LegalImage } from 'src/app/shared/types/content-types';

@Component({
  selector: 'nx-post-footer',
  templateUrl: './post-footer.component.html',
  styleUrls: ['./post-footer.component.scss'],
})
export class PostFooterComponent implements IPostFooter {
  // REQUIRED INPUTS
  @Input() data!: IPostFooter['data'];

  // METHODS
  /**
   * Returns the image source and alt text from the asset
   * @param image Asset object
   * @returns An object with the image source and alt text
   */
  getImage(image: NX23LegalImage): any {
    const file = image.fields.image.fields.file;
    if (file && file.details && 'image' in file.details) {
      const height = 64;
      const proportion = height / (file.details.image?.height ?? 1);
      const width = (file.details.image?.width ?? 1) * proportion;
      return {
        src: image.fields.image.fields.file?.url,
        alt: image.fields.image.fields.description,
        href: image.fields.url,
        width,
        height,
      };
    }
    return null;
  }
}
